
<div [attr.redType]="type" [attr.redSize]="size" >
    <ng-content></ng-content>
</div>
